export default "__VITE_ASSET__CSeKRDaW__"